export const APP_BASE_URL = "http://tatnaywonproperty.com/"
export const IMAGE_URL = "http://tatnaywonproperty.com/uploads/"
export const LogoNotFound = "http://tatnaywonproperty.com/data/default/"
export const TatNayWonLogo = "http://tatnaywonproperty.com/uploads/mobile_app/logo.jpg"
export const DefaultURL = "http://tatnaywonproperty.com/data/mobileapp/"


// export const APP_BASE_URL = "http://localhost/projects/tatnaywonproperty/"
// export const IMAGE_URL = "http://localhost/projects/tatnaywonproperty/uploads/"
// export const LogoNotFound = "http://localhost/projects/tatnaywonproperty/data/default/"
// export const TatNayWonLogo = "http://localhost/projects/tatnaywonproperty/uploads/mobile_app/logo.jpg"
// export const DefaultURL = "http://localhost/projects/tatnaywonproperty/data/mobileapp/"